import { UseFormReturn } from 'react-hook-form';

import { AllEnums, Enum } from '~/data/enums';
import { LegalEntity, getCountryByLegalEntity } from '~/data/legalEntity';
import { filterActiveEnumsByCountryAndOrgUnits } from '~/utils/helper';

import { Form } from './hooks/useRehireEmpForm';

type Field = {
  name: string;
  enum: Enum[];
};

type FieldNames =
  | 'rehire.empPosition.fInternalPositionPosition'
  | 'rehire.employmentDetails.fEmplDetailStatus'
  | 'rehire.employmentDetails.fEmplDetailJobGrade'
  | 'rehire.employment.fEmplFixedTermReason'
  | 'rehire.employment.fEmplTerminationReason';

export const resetEnumsFormValues = (
  legalEntityValue: string | undefined,
  organizationUnitValue: number,
  allEnums: AllEnums,
  formActions: UseFormReturn<Form>,
  legalEntities: LegalEntity[],
) => {
  if (!legalEntityValue) return;

  const dataFields = [
    {
      name: 'rehire.empPosition.fInternalPositionPosition',
      enum: allEnums['EMPLOYEE_POSITION'],
    },
    {
      name: 'rehire.employmentDetails.fEmplDetailStatus',
      enum: allEnums['EMPLOYMENT_STATUS'],
    },
    {
      name: 'rehire.employmentDetails.fEmplDetailJobGrade',
      enum: allEnums['JOB_GRADE'],
    },
    {
      name: 'rehire.employment.fEmplFixedTermReason',
      enum: allEnums['EMPL_FIXED_TERM_REASON'],
    },
    {
      name: 'rehire.employment.fEmplTerminationReason',
      enum: allEnums['EMPL_TERMINATION_REASON'],
    },
  ] as Field[];

  const { getValues, setValue } = formActions;

  dataFields.forEach((field) => {
    const filteredOptions = filterActiveEnumsByCountryAndOrgUnits(
      field.enum,
      getCountryByLegalEntity(+legalEntityValue, legalEntities),
      organizationUnitValue,
    );

    if (
      !filteredOptions.find(
        (o) => o?.code === getValues(field.name as FieldNames),
      )
    ) {
      setValue(field.name as FieldNames, '');
    }
  });

  return dataFields;
};
